import { Message } from "semantic-ui-react";
import React from "react";
import { ButtonText } from "components/Atoms/Button";
import classNames from "classnames";
import { NoDataAvailableDiv } from "components/NoDataAvailableDiv";

interface Props {
  selected: number;
  total: number;
  nothingSelectedMessage: string;
  onAddAll?: () => Promise<void>;
  entityName: string;
}

export const LinkedPanelMessage = (props: Props) => {
  const [isAddingAll, setIsAddingAll] = React.useState<boolean>(false);

  const onAddAll = async () => {
    setIsAddingAll(true);
    await props.onAddAll?.();
    setIsAddingAll(false);
  }

  const displayAddAll = props.onAddAll && props.selected < props.total;
  const messageClassName = displayAddAll ? "flex justify-space-between align-center" : "";

  if (props.total === 0) {
    return <NoDataAvailableDiv />
  }

  return <>
    {props.selected === 0 && <div style={{ paddingLeft: 8 }} className="s1_red">{props.nothingSelectedMessage}</div>}
    <Message className={messageClassName} color={props.selected === props.total ? "green" : "blue"}>
      <span>{props.selected} / {props.total} {props.entityName}</span>
      {displayAddAll && <ButtonText
        className={classNames("no-padding s1_blue")}
        label={RESX.Buttons.AddAll}
        onClick={onAddAll}
        loading={isAddingAll}
      />}
    </Message>
  </>
}